<template>
    <div class="right-title additions">
        <h5>Latest Updates</h5>
        <ul class="list-unstyled mb-0 comment-list" v-for="article in articles" :key="article.nid">
            <li>
                <router-link :to="article.current_path.replace('/fifmiau/web/article/', '/singledetail/')" class="text-light">
                    <div class="commentimg shrink-effect float-left mr-3">
                        <img v-bind:src="article.field_basic_image" alt="" class="img-fluid" />
                    </div>
                    <div class="comment-txt">
                        <h6 class="mb-1">{{ article.title }}</h6>
                        <span><i class="fa fa-calendar"></i> {{ article.revision_timestamp }}</span>
                    </div>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios';

    export default{
        name: 'LatestNews',
        data () {
            return {
                info: null,
                articles:[],
            }
        },
        mounted() {
            axios
                .get('https://api.fifmi.org.au/api/articles')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "article") {
                            this.articles.push(result.data[i]);
                        }
                    }
                });
        }
    }
</script>
